import axios from 'axios';
import { SET_FLOOR, SET_ROOM, SET_ROOMS, SET_VIEW } from '../constants/mutations';

const state = {
    rooms: {},
    floor: 1,
    view: 'dorm',
};

const getters = {
    rooms: (state) => state.rooms,
    floor: (state) => state.floor,
    view: (state) => state.view,
};

const actions = {
    switchFloor({ commit }, floor) {
        commit(SET_FLOOR, floor);
    },
    switchView({ commit }, view) {
        commit(SET_VIEW, view);
    },
    getRoomsAsync({ commit, rootState }) {
        axios.get('/api/rooms').then((res) => {
            commit(SET_ROOMS, res.data);
        });
    },
    resetRooms({ commit }) {
        commit(SET_ROOMS, {});
    },
};

const mutations = {
    [SET_ROOM](state, { roomNumber, count }) {
        state.rooms[roomNumber].count = count;
    },
    [SET_ROOMS](state, payload) {
        state.rooms = payload;
    },
    [SET_FLOOR](state, payload) {
        state.floor = payload;
        state.view = 'floor';
    },
    [SET_VIEW](state, payload) {
        state.view = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
